import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatSelectModule } from '@angular/material/select';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { NgxEchartsModule } from 'ngx-echarts';
import * as echarts from 'echarts';
import { MatIconModule } from '@angular/material/icon';
import { NavbarComponent } from "../navbar/navbar.component";


@Component({
  selector: 'app-normal_mode_dashboard',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatCardModule, MatSelectModule, NgxChartsModule, MatProgressBarModule, MatOptionModule, MatFormFieldModule, NgxEchartsModule, NavbarComponent],
  templateUrl: './normal_mode_dashboard.component.html',
  styleUrls: ['./normal_mode_dashboard.component.css']
})
export class Normal_mode_dashboardComponent implements OnInit{

  constructor() { }

  marketSegments = ['Market 1', 'Market 2'];
  selectedSegment: string = 'market1';
  chartOptions: any={
    title: {
      text: 'Price Curve',
      left: 'center'
    },
    tooltip: {  // ✅ Tooltip added
      trigger: 'axis',
      formatter: '{b}: {c}',  // Show x-value and y-value on hover
      backgroundColor: 'rgba(0, 0, 0, 0.7)',
      textStyle: { color: '#fff' }
    },
    xAxis: {
      type: 'category',
      data: [-3, -2, -1, 0, 1, 2, 3]
    },
    yAxis: {
      type: 'value'
    },
    series: [{
      name: 'Probability Density',
      type: 'line',
      smooth: true,
      areaStyle: {},
      data: [0.01, 0.05, 0.2, 0.4, 0.2, 0.05, 0.01],
      color: 'rgb(134, 157, 242)'
    }]
  };

  view: [number, number] = [500, 300];
  chartConfig = {
    showXAxis: true,
    showYAxis: true,
    gradient: true,
    showLegend: false,
    showXAxisLabel: true,
    showYAxisLabel: true
  };

  // Normal Distribution Line Chart Config
  normalDistConfig = {
    ...this.chartConfig,
    xAxisLabel: 'Standard Deviations',
    yAxisLabel: 'Probability Density',
    colorScheme: { domain: ['#007bff'] }
  };

  // Bar Chart Config
  barChartConfig = {
    ...this.chartConfig,
    xAxisLabel: 'Products',
    yAxisLabel: 'Customers',
    colorScheme: { domain: ['#7aa3e5', '#a8385d', '#aae3f5', '#5aa454'] }
  };



  // Normal Distribution Data (Updated for Area Chart)
  lineChartData = [
    {
      name: 'Normal Distribution',
      series: [
        { name: '-3', value: 0.1 },
        { name: '-2', value: 2.1 },
        { name: '-1', value: 13.6 },
        { name: '0', value: 34.1 },
        { name: '1', value: 34.1 },
        { name: '2', value: 13.6 },
        { name: '3', value: 2.1 },
        { name: '4', value: 0.1 }
      ]
    }
  ];

  // Bar Chart Data
  barChartData = [
    { name: 'France', value: 30000 },
    { name: 'Germany', value: 25000 },
    { name: 'Spain', value: 40000 },
    { name: 'Kazakhstan', value: 20000 },
    { name: 'Ecuador', value: 35000 },
    { name: 'Austria', value: 28000 },

  ];

  // Pie Chart Data
  pieChartData = [
    { name: 'Segment A', value: 30 },
    { name: 'Segment B', value: 50 },
    { name: 'Segment C', value: 20 }
  ];



  productData = [
    { name: 'Product A', value: 150 },
    { name: 'Product B', value: 200 },
    { name: 'Product C', value: 300 },
    { name: 'Product D', value: 120 },
    { name: 'Product e', value: 150 },
    { name: 'Product F', value: 200 },
    { name: 'Product G', value: 300 },
    { name: 'Product H', value: 120 },
  ];

  parameters = [
    { label: 'Initiated', value: 43, color: 'primary', session: 6817, growth: 43.6 },
    { label: 'Processing', value: 72, color: 'accent', session: 4321, growth: 72.2 },
    { label: 'Completed', value: 90, color: 'primary', session: 3120, growth: 50.8 },
    { label: 'Processing', value: 72, color: 'accent', session: 4321, growth: 72.2 },

  ];


  ngOnInit(): void {
    this.initChart();
  }

  initChart(): void {
    const chartDom = document.getElementById('distributionChart')!;
    const myChart = echarts.init(chartDom);
    myChart.setOption(this.chartOptions);
  }
  goBack() {
    window.history.back(); // Navigate to the previous page
  }




}
